export enum Capabilities {
    AUTOMATION_MANAGE = 'automation_manage',
    AUTOMATION_SHOW = 'automation_show',
}
